var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getProgress < 100)?_c('div',[_c('base-progress',{attrs:{"type":"default","value":_vm.getProgress,"label":_vm.$t('finishedplayers')}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }